<template>
  <div class="carousel-list relative">
    <template v-if="total > slidesPerView">
      <div
        :class="['x-button-prev', { disable: !hasPrevPage }]"
        @click="handlePrev"
      >
        <iconpark-icon name="circle-arrow" size="24"></iconpark-icon>
      </div>
      <div
        :class="['x-button-next', { disable: !hasNextPage }]"
        @click="handleNext"
      >
        <iconpark-icon name="circle-arrow" size="24"></iconpark-icon>
      </div>
    </template>
    <Swiper
      v-if="total"
      class="mt-[20px]"
      :slidesPerView="1"
      :slidesPerGroup="4"
      :spaceBetween="16"
      :pagination="true"
      :breakpoints="{
        680: {
          slidesPerView: props.slidesPerView,
          slidesPerGroup: props.slidesPerView,
          pagination: false,
          modules: [],
        },
      }"
      @swiper="onSwiper"
    >
      <slot />
    </Swiper>
    <slot v-else-if="!isMobile" name="empty" />
  </div>
</template>
<script lang="ts" setup>
import { Swiper } from 'swiper/vue'

const { isMobile } = useDevice()

interface CarouselListProps {
  total: number
  slidesPerView?: number
}

const props = withDefaults(defineProps<CarouselListProps>(), {
  slidesPerView: 4,
})

const swiper = ref()

function onSwiper(_swiper: any) {
  swiper.value = _swiper
}

const hasPrevPage = computed(() => {
  return swiper.value?.activeIndex > 0
})

const hasNextPage = computed(() => {
  return swiper.value?.activeIndex + props.slidesPerView < props.total
})

function handlePrev() {
  swiper.value.slidePrev()
}

function handleNext() {
  swiper.value.slideNext()
}
</script>
<style lang="scss" scoped>
.x-button-prev,
.x-button-next {
  position: absolute;
  cursor: pointer;
  &.disable {
    cursor: not-allowed;
    opacity: 0.4;
  }
}

.x-button-prev {
  left: -40px;
  top: 70px;
  transform: rotate(180deg);
}

.x-button-next {
  transform: translateY(3px);
  right: -30px;
  top: 70px;
}
</style>
